export const buildCorporateLoginUrl = ({ activationUrl, corporateLoginUrl }) => {
  return activationUrl ? `${corporateLoginUrl}?activate=true` : corporateLoginUrl;
};
